// extracted by mini-css-extract-plugin
module.exports = {"narrow":"style-module_narrow__2HPrUzHi4nQtDcCLcyHAXC"};